import React, { useState, useEffect }from 'react';
import { useStyles } from './TakisHero.styles';

import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination, A11y, Autoplay, Controller } from 'swiper';

import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { TakisSvg } from '../components/TakisSvgs';
import TakisSlide from '../components/TakisSlide';
import TakisDivider from './TakisDivider';
import PropTypes from 'prop-types';

const Hero = ({data, isProductPage}) => {
  const classes = useStyles();
  const theme = useTheme();
  const onMobile = useMediaQuery(theme.breakpoints.down(theme.breakpoints.values.md));
  const {slides} = data;
  const hasMultipleSlides = slides.length !== 1;
  const firstItem = slides[0];

  const [userIsMoving, setUserIsMoving] = useState()
  const [slideHeights, setSlideHeights] = useState([])
  const [currentHeight, setCurrentHeight] = useState([])
  const [swiperController, setSwiperController] = useState(null)

  const swipperPagination = {
    clickable: true,
    bulletActiveClass:`${classes.takis_pagination_active}`,
    bulletClass:`${classes.takis_pagination_btn}`,
    el:`.swiper-pagination`,
    bulletElement: 'button'

  };
  const swipperNavigation = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  };

  const afterInit = (swiper) => {
    setTimeout(()=>{
      swiper.updateSize()
    }, 1500)
  }

  const setSlideHeightAtindex = (index, height) => {
    setSlideHeights((heights)=>{
      heights[index] = height
      return heights
    })
  }

  const setSwiperHeight = (swiper) => {
    const currentindex = swiper.activeIndex - 1 || 0
    const height = slideHeights[currentindex]
    setCurrentHeight(height)
  }

  useEffect(() => {
    if (swiperController) {
      setTimeout(()=>{
        if (swiperController) {
          const currentindex = swiperController.activeIndex || 0
          const height = slideHeights[currentindex]
          setCurrentHeight(height)
          swiperController.updateSize()
        }
      }, 1500)
    }
  },[swiperController, slideHeights])

  return (
    <div
      className={classes.heroContainer}>
      {hasMultipleSlides ?
        <>
          <Swiper
            className={classes.swiper}
            navigation={swipperNavigation}
            spaceBetween={0}
            loop={true}
            slidesPerView={1}
            speed={450}
            pagination={swipperPagination}
            modules={[Navigation, Pagination, A11y, Autoplay, Controller]}
            tag="section"
            role="region"
            aria-roledescription="carousel"
            onSwiper={setSwiperController}
            watchSlidesProgress={true}
            autoHeight={true}
            a11y={true}
            updateOnImagesReady={true}
            style={{height:
              currentHeight
                ? `${currentHeight}px`
                : 'unset'
              }}
            // This to handle visibility of slides
            onResize={(swiper)=>{
              setSwiperHeight(swiper)
            }}
            onSliderMove={()=>{
              setUserIsMoving(true)
            }}
            onTransitionStart={swiper => {
              setUserIsMoving(true)
            }}
            onSlideChange={(swiper) => {
              setSwiperHeight(swiper)
            }}
            onTransitionEnd={()=>{
              setUserIsMoving(false)
            }}
            onAfterInit={afterInit}
            >
            <p
              className="sr-only"
              slot="container-start"
              >
                This is a carousel, use Next and Previous buttons to navigate, or jump to a slide with the slide dots.
            </p>
            {
              slides.map((item, index) => {
                return(
                  <SwiperSlide
                    key={item.id[0].value}
                    aria-roledescription="slide"
                    className={
                      item.configuration === "align_left"
                        ? classes.left_grid
                        : classes.right_grid
                      }
                      style={{height:
                        slideHeights[index] > 0
                          ? `${slideHeights[index]}px`
                          : 'unset'
                        }}
                      >
                      {({isActive})=>{
                        return (
                          <TakisSlide
                            title={item.title}
                            description={item.description}
                            configuration={item.configuration}
                            bgImages={item.backgroundImages}
                            images={item.mainImages}
                            cta={item.cta}
                            onMobile={onMobile}
                            userIsMoving={userIsMoving}
                            setHeight={(height) => setSlideHeightAtindex(index, height)}
                            isActive={isActive}
                            inlineVideos={{
                              desktopVideo: item.desktopVideo,
                              mobileVideo: item.mobileVideo
                            }}
                          />
                        )
                      }}
                  </SwiperSlide>
                )
              })
            }

            <div className={`${classes.slide_footer} ${classes.div_mask_block}`}/>

            {/* NAV */}
            <div className={classes.navContainer}>
              <button
                className={`swiper-button-prev ${classes.navigation_button}`}
                title="Got to Previous slide"
                >
                <span className="sr-only">Previous slide</span>
                <TakisSvg
                  icon="leftArrow"
                  svg_class={classes.navigation_svg}
                  viewbox="0 0 32 32"
                  ariaHidden="true"
                />
              </button>
              <button
                className={`swiper-button-next ${classes.right_btn} ${classes.navigation_button}`}
                title="Got to Next slide"
                >
                <span className="sr-only">Next slide</span>
                <TakisSvg
                  icon="rightArrow"
                  svg_class={classes.navigation_svg}
                  viewbox="0 0 32 32"
                  ariaHidden="true"
                />
              </button>
            </div>

            {/* PAGINATION */}
            <div className={`swiper-pagination ${classes.takis_pagination}`}/>

            {/* DIVIDER */}
            <TakisDivider
              modifier={`${classes.slide_footer} ${classes.div_mask}`}
              marginModifier={classes.hero_divider_margin}
              variation={1}
            />
          </Swiper>
        </>
      :
        <>
          <div className={classes.hero_div}>
            <TakisSlide
              title={firstItem.title}
              description={firstItem.description}
              configuration={firstItem.configuration}
              bgImages={firstItem.backgroundImages}
              images={firstItem.mainImages}
              cta={firstItem.cta}
              onMobile={onMobile}
              isActive={true}
              inlineVideos={{
                desktopVideo: firstItem.desktopVideo,
                mobileVideo: firstItem.mobileVideo
              }}
              isProductPage={isProductPage}
              userIsMoving={userIsMoving}
            />
          </div>
          <TakisDivider
            backgroundColor={isProductPage ? "transparent" : "texturePurple"}
            marginModifier={classes.hero_divider_margin}
            isProductPage={isProductPage}
            variation={isProductPage ? 5 : 1}
          />
        </>
      }
    </div>
  )
}

Hero.propTypes = {
  data: PropTypes.object
}

export default Hero;
